/*
* 2022年10月13日16:11:45 LXC
* 其它共用方法
* */
import Vue from 'vue';
import CryptoJS from 'crypto-js';
import { Request, Problem, unEncryptedConfig, getTokenHeader, getHeader } from './request';
import self from '@/common/utils/global-config';
import * as Constants from '@/common/utils/constants';

// ---START-普通缓存处理-START---
/*
* 存储 LOCAL 信息
* 对数据进行 LOCAL 的存储
* title[string]：缓存名称字符串
* info[any]：待缓存数据
* */
export function setLocalStorage(title, info, json = true) {
  window.localStorage.setItem(title, json ? JSON.stringify(info) : info);
}

/*
* 存储 SESSION 信息
* 对数据进行 SESSION 的存储
* title[string]：缓存名称字符串
* info[any]：待缓存数据
* */
export function setSessionStorage(title, info, json = true) {
  window.sessionStorage.setItem(title, json ? JSON.stringify(info) : info);
}

export function setCookie(title, info) {
  if (!self.$sn.validate.string(info)) info = JSON.stringify(info);
  const exp = new Date();
  exp.setTime(exp.getTime() + 365 * 24 * 60 * 60 * 1000);
  document.cookie = title + '=' + encodeURIComponent(info) + ';expires=' + exp.toGMTString();
}

/*
* 获取 LOCAL 信息
* 获取指定名称的 LOCAL 缓存
* title[string]：缓存名称字符串
* */
export function getLocalStorage(title) {
  if (!self.$sn.validate.empty(window.localStorage.getItem(title))) {
    return self.$sn.validate.json(window.localStorage.getItem(title)) ? JSON.parse(window.localStorage.getItem(title)) : window.localStorage.getItem(title);
  }
  return null;
}

/*
* 获取 SESSION 信息
* 获取指定名称的 SESSION 缓存
* title[string]：缓存名称字符串
* */
export function getSessionStorage(title) {
  if (!self.$sn.validate.empty(window.sessionStorage.getItem(title))) {
    return self.$sn.validate.json(window.sessionStorage.getItem(title)) ? JSON.parse(window.sessionStorage.getItem(title)) : window.sessionStorage.getItem(title);
  }
  return null;
}

export function getCookie(title) {
  const c = document.cookie.match(new RegExp('(^| )' + title + '=([^;]*)(;|$)'));
  if (!self.$sn.validate.empty(c) && c.length > 1) {
    if (self.$sn.validate.json(decodeURIComponent(c[2]))) {
      return JSON.parse(decodeURIComponent(c[2]));
    }
    else {
      return decodeURIComponent(c[2]);
    }
  }
  else {
    return null;
  }
}

/*
* 删除 LOCAL 信息
* 删除指定名称的 LOCAL 缓存
* title[string]：缓存名称字符串
* */
export function removeLocalStorage(title) {
  if (!self.$sn.validate.empty(window.localStorage.getItem(title))) {
    window.localStorage.removeItem(title);
  }
}

/*
* 删除 SESSION 信息
* 删除指定名称的 SESSION 缓存
* title[string]：缓存名称字符串
* */
export function removeSessionStorage(title) {
  if (!self.$sn.validate.empty(window.sessionStorage.getItem(title))) {
    window.sessionStorage.removeItem(title);
  }
}

export function removeCookie(title) {
  const exp = new Date();
  exp.setTime(exp.getTime() - 1);
  const c = getCookie(title);
  if (c) {
    document.cookie = title + '=' + c + ';expires=' + exp.toGMTString();
  }
}
// ---END-普通缓存处理-END---

// ---START-医院相关缓存处理-START---
/*
* 存储医院 LOCAL 信息
* 对数据进行 LOCAL 的存储
* title[string]：缓存名称字符串
* info[any]：待缓存数据
* */
export function setHospitalLocalStorage(title, info, json = true) {
  window.localStorage.setItem(getHospitalId() + '_' + title, json ? JSON.stringify(info) : info);
}

/*
* 存储医院 SESSION 信息
* 对数据进行 SESSION 的存储
* title[string]：缓存名称字符串
* info[any]：待缓存数据
* */
export function setHospitalSessionStorage(title, info, json = true) {
  window.sessionStorage.setItem(getHospitalId() + '_' + title, json ? JSON.stringify(info) : info);
}

export function setHospitalCookie(title, info) {
  if (!self.$sn.validate.string(info)) info = JSON.stringify(info);
  const exp = new Date();
  exp.setTime(exp.getTime() + 365 * 24 * 60 * 60 * 1000);
  document.cookie = getHospitalId() + '_' + title + '=' + encodeURIComponent(info) + ';expires=' + exp.toGMTString();
}

/*
* 获取医院 LOCAL 信息
* 获取指定名称的 LOCAL 缓存
* title[string]：缓存名称字符串
* */
export function getHospitalLocalStorage(title) {
  if (!self.$sn.validate.empty(window.localStorage.getItem(getHospitalId() + '_' + title))) {
    return self.$sn.validate.json(window.localStorage.getItem(getHospitalId() + '_' + title)) ? JSON.parse(window.localStorage.getItem(getHospitalId() + '_' + title)) : window.localStorage.getItem(getHospitalId() + '_' + title);
  }
  return null;
}

/*
* 获取医院 SESSION 信息
* 获取指定名称的 SESSION 缓存
* title[string]：缓存名称字符串
* */
export function getHospitalSessionStorage(title) {
  if (!self.$sn.validate.empty(window.sessionStorage.getItem(getHospitalId() + '_' + title))) {
    return self.$sn.validate.json(window.sessionStorage.getItem(getHospitalId() + '_' + title)) ? JSON.parse(window.sessionStorage.getItem(getHospitalId() + '_' + title)) : window.sessionStorage.getItem(getHospitalId() + '_' + title);
  }
  return null;
}

export function getHospitalCookie(title) {
  const c = document.cookie.match(new RegExp('(^| )' + getHospitalId() + '_' + title + '=([^;]*)(;|$)'));
  if (!self.$sn.validate.empty(c) && c.length > 1) {
    if (self.$sn.validate.json(decodeURIComponent(c[2]))) {
      return JSON.parse(decodeURIComponent(c[2]));
    }
    else {
      return decodeURIComponent(c[2]);
    }
  }
  else {
    return null;
  }
}

/*
* 删除医院 LOCAL 信息
* 删除指定名称的 LOCAL 缓存
* title[string]：缓存名称字符串
* */
export function removeHospitalLocalStorage(title) {
  if (!self.$sn.validate.empty(window.localStorage.getItem(getHospitalId() + '_' + title))) {
    window.localStorage.removeItem(getHospitalId() + '_' + title);
  }
}

/*
* 删除医院 SESSION 信息
* 删除指定名称的 SESSION 缓存
* title[string]：缓存名称字符串
* */
export function removeHospitalSessionStorage(title) {
  if (!self.$sn.validate.empty(window.sessionStorage.getItem(getHospitalId() + '_' + title))) {
    window.sessionStorage.removeItem(getHospitalId() + '_' + title);
  }
}

export function removeHospitalCookie(title) {
  const exp = new Date();
  exp.setTime(exp.getTime() - 1);
  const c = getCookie(getHospitalId() + '_' + title);
  if (c) {
    document.cookie = getHospitalId() + '_' + title + '=' + c + ';expires=' + exp.toGMTString();
  }
}
// ---END-医院相关缓存处理-END---

// ---START-加解密相关处理-START---
/*
* 加密方法
* variable[json]：待加密字符串
* secret[string]：公钥
* */
export function variableEncryption(variable, secret = 'shunnengcnsecret') {
  if (self.$sn.validate.empty(variable)) {
    return '';
  }
  const key = CryptoJS.enc.Utf8.parse(secret);
  const iv = CryptoJS.enc.Utf8.parse(secret);
  const transit = CryptoJS.enc.Utf8.parse(variable);
  const encryption = CryptoJS.AES.encrypt(transit, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encryption.ciphertext.toString();
}

/*
* 解密方法
* variable[string]：待解密字符串
* secret[string]：公钥
* */
export function variableDecryption(variable, secret = 'shunnengcnsecret') {
  if (self.$sn.validate.empty(variable)) {
    return '';
  }
  const key = CryptoJS.enc.Utf8.parse(secret);
  const iv = CryptoJS.enc.Utf8.parse(secret);
  const first = CryptoJS.enc.Hex.parse(variable);
  const secondary = CryptoJS.enc.Base64.stringify(first);
  const decryption = CryptoJS.AES.decrypt(secondary, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return decryption.toString(CryptoJS.enc.Utf8);
}

// ---END-加解密相关处理-END---

// ---START-登录信息相关处理-START---
// 主账号
export function getAccountId() {
  let id = '';
  if (self.$sn.vuex.get('vuex_login_user.' + getHospitalId()) && self.$sn.vuex.get('vuex_login_user.' + getHospitalId()).mobile) {
    id = self.$sn.vuex.get('vuex_login_user.' + getHospitalId()).mobile;
  }
  return id;
}

// 登录状态
export function getLoginCondition() {
  let login = false;
  if (self.$sn.vuex.get('vuex_login_user.' + getHospitalId()) && self.$sn.vuex.get('vuex_login_user.' + getHospitalId()).isLogin) {
    login = self.$sn.vuex.get('vuex_login_user.' + getHospitalId()).isLogin;
  }
  return login;
}

// 登录手机号
export function getLoginPhone() {
  let phone = '';
  if (self.$sn.vuex.get('vuex_login_user.' + getHospitalId()) && self.$sn.vuex.get('vuex_login_user.' + getHospitalId()).mobile) {
    phone = self.$sn.vuex.get('vuex_login_user.' + getHospitalId()).mobile;
  }
  return phone;
}

// OpenId
export function getOpenId() {
  let id = '';
  if (self.$sn.vuex.get('vuex_login_user.' + getHospitalId()) && self.$sn.vuex.get('vuex_login_user.' + getHospitalId()).platformDetail && self.$sn.vuex.get('vuex_login_user.' + getHospitalId()).platformDetail.userId) {
    id = self.$sn.vuex.get('vuex_login_user.' + getHospitalId()).platformDetail.userId;
  }
  return id;
}

export function getOpenIdByPhone(phone) {
  return phone + getPlatformType();
}
// ---END-登录信息相关处理-END---

// ---START-功能相关处理-START---
/*
* 取功能信息
* id[string]：功能 ID
* */
export function getFunction(id) {
  if (self.$sn.validate.empty(id)) return {};
  const digit = getHospitalSessionStorage('HospitalFunctionInformation');
  if (self.$sn.validate.empty(digit) || !self.$sn.validate.array(digit)) return {};
  const func = digit.find(result => result.moduleId === id) || {};
  return func;
}

/*
* 是否展示当前功能
* 如果功能 ID 包含 other 及当前医院 ID ，则此功能默认为三方功能，直接返回 true；不再进行后续处理
* 如果功能 ID 包含英文逗号，处理为任意功能信息存在，则返回 true；反之，返回 false
* id[string]：功能 ID
* eg：$sn.utils.isShowFunction(id)
* */
export function isShowFunction(id) {
  if (self.$sn.validate.empty(id)) return false;
  if (id.indexOf('other') !== -1 && id.indexOf(getHospitalId()) !== -1) return true;
  if (id.indexOf('ordinary') !== -1) return true;
  const digit = id.split(',');
  if (digit.length > 1) {
    let verify = false;
    for (let i = 0; i < digit.length; i++) {
      if (!self.$sn.validate.empty(getFunction(digit[i]))) {
        verify = true;
        break;
      }
    }
    return verify;
  }
  else return !self.$sn.validate.empty(getFunction(id));
}

/*
* 是否开通当前功能
* 如果功能 ID 包含 other 及当前医院 ID ，则此功能默认为三方功能，直接返回 true；不再进行后续处理
* 如果功能 ID 包含英文逗号，处理为任意功能信息开通，则返回 true；反之，返回 false
* id[string]：功能 ID
* eg：$sn.utils.isOpenFunction(id)
* */
export function isOpenFunction(id) {
  if (self.$sn.validate.empty(id)) return false;
  if (id.indexOf('other') !== -1 && id.indexOf(getHospitalId()) !== -1) return true;
  if (id.indexOf('ordinary') !== -1) return true;
  const digit = id.split(',');
  if (digit.length > 1) {
    let verify = false;
    for (let i = 0; i < digit.length; i++) {
      const func = getFunction(digit[i]);
      if (!self.$sn.validate.empty(func) && func.isUse === '1') {
        verify = true;
        break;
      }
    }
    return verify;
  }
  else {
    const func = getFunction(id);
    return !self.$sn.validate.empty(func) && func.isUse === '1';
  }
}

/*
* 当前功能别名 or 副标题 or 其他功能信息
* 首项[string]：0：别名；1：副标题；其他功能信息字段名称
* 后续项[string]：功能 ID
* eg：$sn.utils.getFunctionTitle('0', id)
* */
export function getFunctionTitle(...args) {
  const digit = args;
  if (self.$sn.validate.empty(digit) || digit.length <= 1) return '';
  const type = digit[0];
  if (self.$sn.validate.empty(type)) return '';
  const id = digit[1];
  const func = getFunction(id);
  if (!self.$sn.validate.empty(func)) {
    if (type === '0') return func.alias || func.moduleName || '';
    else if (type === '1') return func.subtitle || '';
    else return func[type] || '';
  }
  else return '';
}
// ---END-功能相关处理-END---

// ---START-医院相关处理-START---
// 医院 ID
export function getHospitalId() {
  let id = '';
  if (getLocalStorage('hosId')) {
    id = getLocalStorage('hosId');
  }
  return id;
}

// 医院名称
export function getHospitalTitle() {
  let title = '';
  if (getHospitalLocalStorage('HospitalInformation') && getHospitalLocalStorage('HospitalInformation').hosName) {
    title = getHospitalLocalStorage('HospitalInformation').hosName;
  }
  return title;
}

// 院区 ID
export function getHospitalAreaId() {
  let id = '';
  if (getHospitalLocalStorage('HospitalAreaInformation') && getHospitalLocalStorage('HospitalAreaInformation').length > 0 && getHospitalLocalStorage('HospitalAreaInformation')[0].areaId) {
    id = getHospitalLocalStorage('HospitalAreaInformation')[0].areaId;
  }
  return id;
}

/*
院区信息
areaId[string]：目标院区的院区 ID；如不传，则返回所有院区信息
*/
export function getHospitalAreaInformation(id) {
  let area;
  const entire = getHospitalLocalStorage('HospitalAreaInformation') || [];
  if (entire && entire.length > 0) {
    if (id) {
      if (!self.$sn.validate.empty(entire.find(result => result.areaId === id))) area = entire.find(result => result.areaId === id);
      else area = {};
    }
    else area = entire;
  }
  else area = {};
  return area;
}
// ---END-医院相关处理-END---

// ---START-项目相关处理-START---
// 平台类型
export function getPlatformType() {
  return Constants.PLATFORM_TYPE_PC;
}

/*
平台 ID
type[string]：平台类型
 */
export function getPlatformId() {
  return Constants.PLATFORM_ID_PC;
}

// 支付类型
export function getRegType(reg) {
  return self.$sn.getConfig('regType') || reg;
}

/*
子支付类型
type[string]：支付类型
 */
export function getSubRegType(reg, type = getRegType()) {
  const info = {};
  const sub = [Constants.REG_TYPE_UMS, Constants.REG_TYPE_UPUP, Constants.REG_TYPE_YUANQI1, Constants.REG_TYPE_YUANQI2, Constants.REG_TYPE_JN, Constants.REG_TYPE_WN, Constants.REG_TYPE_DW];
  sub.forEach(el => {
    if (reg === Constants.REG_TYPE_WECHAT) {
      Vue.set(info, el, 'WeChat');
    }
    else if (reg === Constants.REG_TYPE_ALIPAY) {
      Vue.set(info, el, 'Alipay');
    }
  });
  return info[type];
}

// 项目类型
export function getProjectType() {
  return Constants.PROJECT_TYPE_PC;
}

export function isYuanQi() {
  return [Constants.REG_TYPE_YUANQI1, Constants.REG_TYPE_YUANQI2].includes(getRegType());
}

export function getProjectPattern() {
  return getLocalStorage('projectPattern') || '';
}
// ---END-项目相关处理-END---

// ---START-须知相关处理-START---
export function storeTipCaption(type) {
  let storage = getHospitalSessionStorage('LoginUser_TipCaption');
  if (self.$sn.validate.empty(storage)) storage = [];
  if (self.$sn.validate.empty(storage.find(result => result === type))) storage.push(type);
  setHospitalSessionStorage('LoginUser_TipCaption', storage);
}

export function verifyTipCaption(type) {
  const storage = getHospitalSessionStorage('LoginUser_TipCaption');
  return self.$sn.validate.empty(storage) || self.$sn.validate.empty(storage.find(result => result === type));
}
// ---END-须知相关处理-END---

// 当前就诊人
export function getCurrentPatient() {
  if (!self.$sn.validate.empty(getHospitalLocalStorage('CurrentPatient'))) {
    return getHospitalLocalStorage('CurrentPatient');
  }
  else {
    let patient = null;
    if (getHospitalLocalStorage('Login_PatientList') && getHospitalLocalStorage('Login_PatientList').length > 0) {
      const match = getHospitalLocalStorage('Login_PatientList').find(result => result.defaultState === '1');
      if (self.$sn.validate.empty(match)) {
        patient = getHospitalLocalStorage('Login_PatientList')[0];
      }
      else {
        patient = match;
      }
      setHospitalLocalStorage('CurrentPatient', patient);
    }
    return patient;
  }
}

/*
* 当前时间
* 获取当前时间，优先返回服务器时间；如无服务器时间，则返回本地时间
* */
export function getCurrentTime() {
  return new Date();
}

/*
* URL 上相关信息
* title[string]：字段名称
* */
export function getUrlVariable(title) {
  if (self.$sn.validate.empty(title)) {
    return '';
  }
  const titleRegExp = new RegExp('(^|&)' + title + '=([^&]*)(&|$)');
  const r = window.location.search.substr(1).match(titleRegExp);
  if (r) {
    return unescape(r[2]);
  }
  else {
    return '';
  }
}

export function getProtocol() {
  if (document.location.protocol === 'https:') return 'https:';
  return 'http:';
}

/*
* 通用调用服务方法
* domain[string]：域名
* url[string]：服务地址，在 swagger.js 中进行配置，不允许在页面中直接写；如果遇到参数为 path 类型，则使用 $sn.format.caption 全局方法来进行格式化处理后再传入
* query[object]：参数为 query 类型，格式参照 https://www.uviewui.com/js/queryParams.html，可在对象中传入 prefix 和 format，指定格式化方式
* method[string]：GET，POST，PUT，DELETE
* header[boolean]：是否需要 token
* data[json]：body 入参
* emulateJSON[boolean]
* reload[boolean]: 是否需要重发，默认值为 true
* success[function]：访问成功（then）后需调用的方法
* fail[function]：访问失败（catch）后需调用的方法
* first[any]：调用服务时在成功回调业务处理中要用到的信息
* secondary[any]：调用服务时在失败回调业务处理中要用到的信息
* */
export function ordinaryRequest(params, success, fail, first, secondary) {
  if (self.$sn.validate.empty(params.domain)) params.domain = 'offline';
  const DomainCompare = {
    // 单点医院
    'offline': process.env.VUE_APP_LOCALHOST,
    // OSS 静态文件库
    'static': Constants.ALI_CLOUD_DOMAIN_STATIC
  };
  if (Object.keys(DomainCompare).includes(params.domain)) {
    params.domain = DomainCompare[params.domain];
  }
  if (params.query) {
    const prefix = typeof params.query.prefix !== 'boolean' ? true : params.query.prefix;
    const format = params.query.format ? params.query.format : 'repeat';
    const empty = typeof params.query.empty !== 'boolean' ? true : params.query.empty;
    if (typeof params.query.prefix === 'boolean') {
      delete params.query.prefix;
    }
    if (params.query.format) {
      delete params.query.format;
    }
    if (typeof params.query.empty === 'boolean') {
      delete params.query.empty;
    }
    params.url += self.$sn.format.reverseObjectParameter(params.query, prefix, format, empty);
  }
  if (typeof params.reload === 'boolean' && !params.reload) {
    let verify = false;
    unEncryptedConfig.forEach(el => {
      if (params.url.indexOf(el) !== -1) verify = true;
    });
    if (verify) params.domain = params.domain.replace('/encrypt', '');
    if (params.domain.indexOf('encrypt') !== -1) {
      if (params.method === 'POST') {
        if (params.data) {
          params.data = variableEncryption(params.data);
        }
      }
      else if (params.method === 'PUT') {
        params.domain = params.domain.replace('/encrypt', '');
      }
    }
    return Vue.http({
      url: params.domain + params.url,
      method: params.method || 'GET',
      headers: params.header ? getTokenHeader({
        url: params.domain + params.url,
        method: params.method || 'GET',
        data: params.data || ''
      }) : getHeader({
        url: params.domain + params.url,
        method: params.method || 'GET',
        data: params.data || ''
      }),
      body: params.data || '',
      emulateJSON: params.emulateJSON || true
    }).then(result => {
      if (params.domain.indexOf('encrypt') !== -1) {
        if (result && result.data && result.data.data) {
          result.data.data = JSON.parse(variableDecryption(result.data.data));
        }
      }
      if (typeof success === 'function') {
        return success(result, first) || result.data;
      }
      else {
        return result.data;
      }
    }).catch(error => {
      if (typeof fail === 'function') {
        return fail(error, secondary) || Problem(error, secondary);
      }
      else {
        return Problem(error, secondary);
      }
    });
  }
  else {
    return Request({
      url: params.domain + params.url,
      method: params.method,
      header: params.header,
      data: params.data,
      emulateJSON: params.emulateJSON
    }).then(result => {
      if (typeof success === 'function') {
        return success(result, first) || result.data;
      }
      else {
        return result.data;
      }
    }).catch(error => {
      if (typeof fail === 'function') {
        return fail(error, secondary) || Problem(error, secondary);
      }
      else {
        return Problem(error, secondary);
      }
    });
  }
}
